<script lang="ts">
  interface Props {
    active: boolean
    animationFinished: () => void
  }

  let {
    active,
    animationFinished,
  }: Props = $props();

  let show = $state<boolean>(true);

  $effect(() => {
    if (!active) {
      setTimeout(() => {
        animationFinished();
        show = false;
      }, 1000);
    }
  });
</script>

{#if show}
    <oc-skeleton-v1 class={{ 'ft5-upselling-skeleton': true, 'ft5-upselling-opacity-0': !active }}></oc-skeleton-v1>
{/if}

<style lang="scss">
  .ft5-upselling-skeleton {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    transition: opacity 1s;
  }

  .ft5-upselling-opacity-0 {
    opacity: 0;
  }
</style>
